import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js", { scope: "/" })
            .then((reg) => console.log("SW зарегистрирован:", reg.scope))
            .catch((err) => console.error("Ошибка регистрации SW:", err));
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
